import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import SEO from '../../components/base/SEO';

export default function Compare() {
  const [selectedCompetitor, setSelectedCompetitor] = useState('all');

  const competitors = [
    {
      id: 'hootsuite',
      name: 'Hootsuite',
      icon: 'ri-share-circle-line',
      tagline: 'Enterprise social media management',
      startingPrice: '$99/mo',
      color: 'from-indigo-600 to-purple-600',
    },
    {
      id: 'buffer',
      name: 'Buffer',
      icon: 'ri-bar-chart-grouped-line',
      tagline: 'Simple scheduling and analytics',
      startingPrice: '$6/mo',
      color: 'from-blue-500 to-blue-600',
    },
    {
      id: 'sproutsocial',
      name: 'Sprout Social',
      icon: 'ri-seedling-line',
      tagline: 'All-in-one social media suite',
      startingPrice: '$249/mo',
      color: 'from-green-500 to-green-600',
    },
    {
      id: 'later',
      name: 'Later',
      icon: 'ri-calendar-schedule-line',
      tagline: 'Visual Instagram planner',
      startingPrice: '$25/mo',
      color: 'from-pink-500 to-rose-600',
    },
    {
      id: 'sendible',
      name: 'Sendible',
      icon: 'ri-rocket-2-line',
      tagline: 'Agency-focused management',
      startingPrice: '$29/mo',
      color: 'from-orange-500 to-red-600',
    },
  ];

  const featureComparison = [
    {
      category: 'AI & Automation',
      features: [
        { name: 'AI Content Generation', mandapost: true, hootsuite: false, buffer: false, sproutsocial: false, later: false, sendible: false },
        { name: 'Agentic AI Planning', mandapost: true, hootsuite: false, buffer: false, sproutsocial: false, later: false, sendible: false },
        { name: 'Smart Platform Adaptation', mandapost: true, hootsuite: false, buffer: false, sproutsocial: true, later: false, sendible: false },
        { name: 'AI Caption Suggestions', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
      ],
    },
    {
      category: 'Content Planning',
      features: [
        { name: 'The Playground (Daily Ideas)', mandapost: true, hootsuite: false, buffer: false, sproutsocial: false, later: false, sendible: false },
        { name: 'Visual Feed Planner', mandapost: true, hootsuite: false, buffer: false, sproutsocial: false, later: true, sendible: false },
        { name: 'Content Calendar', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'Bulk Scheduling', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
      ],
    },
    {
      category: 'Analytics & Reporting',
      features: [
        { name: 'Competitor Analysis', mandapost: true, hootsuite: true, buffer: false, sproutsocial: true, later: false, sendible: true },
        { name: 'Campaign Tracking', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'Custom Reports', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'Real-time Analytics', mandapost: true, hootsuite: true, buffer: false, sproutsocial: true, later: false, sendible: true },
      ],
    },
    {
      category: 'Platform Support',
      features: [
        { name: 'Instagram', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'Facebook', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'Twitter/X', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'TikTok', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'LinkedIn', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'Blue Sky', mandapost: true, hootsuite: false, buffer: false, sproutsocial: false, later: false, sendible: false },
        { name: 'Lemon8', mandapost: true, hootsuite: false, buffer: false, sproutsocial: false, later: false, sendible: false },
      ],
    },
    {
      category: 'Team Collaboration',
      features: [
        { name: 'Kanban Board', mandapost: true, hootsuite: false, buffer: false, sproutsocial: false, later: false, sendible: false },
        { name: 'Team Workflows', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'Client Access', mandapost: true, hootsuite: true, buffer: false, sproutsocial: true, later: false, sendible: true },
        { name: 'Approval Workflows', mandapost: true, hootsuite: true, buffer: false, sproutsocial: true, later: false, sendible: true },
      ],
    },
    {
      category: 'Additional Tools',
      features: [
        { name: 'Media Library', mandapost: true, hootsuite: true, buffer: true, sproutsocial: true, later: true, sendible: true },
        { name: 'Short Link Generator', mandapost: true, hootsuite: true, buffer: false, sproutsocial: true, later: false, sendible: true },
        { name: 'Email Campaigns', mandapost: true, hootsuite: false, buffer: false, sproutsocial: false, later: false, sendible: true },
        { name: 'Client Invoicing', mandapost: true, hootsuite: false, buffer: false, sproutsocial: false, later: false, sendible: false },
      ],
    },
  ];

  const detailedComparisons = [
    {
      id: 'hootsuite',
      name: 'Hootsuite',
      icon: 'ri-share-circle-line',
      description: 'Enterprise-grade social media management platform with robust features for large teams.',
      whyMandaPost: [
        'Agentic AI generates content tailored to each platform automatically',
        'The Playground provides 247+ daily content ideas vs. manual planning',
        'More affordable pricing starting at just $29/mo vs. $99/mo',
        'Modern, intuitive interface designed for today\'s marketers',
        'Built-in client invoicing and project management tools',
      ],
      whyHootsuite: [
        'Longer track record and established enterprise relationships',
        'More extensive third-party app integrations',
        'Advanced social listening capabilities',
        'Larger support team and training resources',
      ],
      bestFor: {
        mandapost: 'Small to medium agencies, solopreneurs, and teams wanting AI-powered automation',
        competitor: 'Large enterprises with complex workflows and extensive integration needs',
      },
    },
    {
      id: 'buffer',
      name: 'Buffer',
      icon: 'ri-bar-chart-grouped-line',
      description: 'Simple, user-friendly social media scheduling tool focused on ease of use.',
      whyMandaPost: [
        'intelligent content creation saves hours vs. manual writing',
        'Competitor analysis and campaign tracking built-in',
        'Visual feed planner for Instagram grid planning',
        'Team collaboration with Kanban boards',
        'More platforms supported (Blue Sky, Lemon8)',
      ],
      whyBuffer: [
        'Lower entry price point ($6/mo for basic)',
        'Extremely simple learning curve',
        'Strong focus on analytics and insights',
        'Popular Pablo image creation tool',
      ],
      bestFor: {
        mandapost: 'Creators and businesses wanting intelligent automation without complexity',
        competitor: 'Individuals and small teams prioritizing simplicity over advanced features',
      },
    },
    {
      id: 'sproutsocial',
      name: 'Sprout Social',
      icon: 'ri-seedling-line',
      description: 'Comprehensive social media management suite with powerful analytics and reporting.',
      whyMandaPost: [
        'Agentic AI vs. manual content creation workflows',
        '90% lower cost ($29/mo vs. $249/mo starting)',
        'The Playground feature provides daily trending content ideas',
        'Built-in invoicing and client management',
        'Faster setup and onboarding process',
      ],
      whySproutSocial: [
        'Industry-leading analytics and reporting',
        'Sophisticated social listening tools',
        'CRM integration capabilities',
        'Enterprise-level customer support',
      ],
      bestFor: {
        mandapost: 'Budget-conscious agencies and growing businesses needing AI assistance',
        competitor: 'Large enterprises requiring advanced analytics and social listening',
      },
    },
    {
      id: 'later',
      name: 'Later',
      icon: 'ri-calendar-schedule-line',
      description: 'Visual-first social media planner specializing in Instagram marketing.',
      whyMandaPost: [
        'AI content generation across all platforms, not just visual planning',
        'Multi-platform management beyond Instagram focus',
        'Advanced analytics with competitor comparison',
        'Team collaboration tools and workflows',
        'Email marketing and press release capabilities',
      ],
      whyLater: [
        'Best-in-class visual Instagram planner',
        'Strong focus on influencer marketing',
        'Linkin.bio landing page builder',
        'Instagram-specific features and optimizations',
      ],
      bestFor: {
        mandapost: 'Multi-platform marketers needing intelligent content across all channels',
        competitor: 'Instagram-focused creators and brands prioritizing visual aesthetics',
      },
    },
    {
      id: 'sendible',
      name: 'Sendible',
      icon: 'ri-rocket-2-line',
      description: 'Agency-focused social media management platform with white-label options.',
      whyMandaPost: [
        'Agentic AI creates content automatically vs. manual workflows',
        'More intuitive Kanban-style project management',
        'The Playground for never-ending content inspiration',
        'Built-in invoicing eliminates separate billing tools',
        'Modern UI designed for today\'s workflows',
      ],
      whySendible: [
        'White-label branding for agencies',
        'Extensive client management features',
        'Strong Google My Business integration',
        'Established agency-specific workflows',
      ],
      bestFor: {
        mandapost: 'Agencies wanting intelligent automation and modern workflows',
        competitor: 'Agencies requiring white-label branding and established client structures',
      },
    },
  ];

  return (
    <div className="min-h-screen bg-white font-['Montserrat']">
      <SEO
        title="Compare - MandaPost vs Hootsuite, Buffer, Sprout Social"
        description="Compare MandaPost with leading social media management tools. See how our AI-powered platform saves you 90% vs enterprise tools while offering more features."
        keywords="social media comparison, hootsuite alternative, buffer alternative, sprout social alternative, social media tools comparison"
        canonicalUrl="https://mandapost.com/compare"
      />
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-[#22577A] to-[#38a3a5] text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#66b3ff] rounded-full blur-3xl"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center px-4 py-2 bg-white/20 rounded-full font-medium mb-6">
              <i className="ri-contrast-line mr-2"></i>
              Compare & Choose
            </div>

            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-7xl font-bold mb-6 leading-tight">
              MandaPost vs.
              <span className="block text-[#e4f4ff]">The Competition</span>
            </h1>

            <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-10 leading-relaxed">
              See how MandaPost's Agentic AI and intelligent automation stack up against traditional social media management tools.
            </p>

            <div className="flex flex-wrap gap-3 justify-center">
              {competitors.map((competitor) => (
                <button
                  key={competitor.id}
                  onClick={() => setSelectedCompetitor(competitor.id)}
                  className={`px-6 py-3 rounded-xl font-semibold transition-all ${
                    selectedCompetitor === competitor.id
                      ? 'bg-white text-[#22577A] shadow-xl scale-105'
                      : 'bg-white/20 text-white hover:bg-white/30'
                  }`}
                >
                  <i className={competitor.icon}></i> {competitor.name}
                </button>
              ))}
              <button
                onClick={() => setSelectedCompetitor('all')}
                className={`px-6 py-3 rounded-xl font-semibold transition-all ${
                  selectedCompetitor === 'all'
                    ? 'bg-white text-[#22577A] shadow-xl scale-105'
                    : 'bg-white/20 text-white hover:bg-white/30'
                }`}
              >
                View All
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Stats */}
      <section className="py-12 bg-white border-b-2 border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#22577A] mb-2">90%</div>
              <div className="text-gray-600">Lower Cost vs. Enterprise Tools</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#22577A] mb-2">247+</div>
              <div className="text-gray-600">Daily Content Ideas</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#22577A] mb-2">7+</div>
              <div className="text-gray-600">Social Platforms</div>
            </div>
            <div className="text-center">
              <div className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#22577A] mb-2">AI-First</div>
              <div className="text-gray-600">Agentic AI Technology</div>
            </div>
          </div>
        </div>
      </section>

      {/* Feature Comparison Table */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-[#e4f4ff]/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#22577A] mb-6">
              Feature-by-Feature Comparison
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              See how MandaPost's innovative features compare across the industry's leading platforms.
            </p>
          </div>

          <div className="bg-white rounded-2xl border-2 border-gray-200 overflow-hidden shadow-lg">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead className="bg-gradient-to-r from-[#22577A] to-[#38a3a5] text-white">
                  <tr>
                    <th className="px-6 py-4 text-left font-semibold">Feature</th>
                    <th className="px-6 py-4 text-center font-semibold">
                      <div className="flex flex-col items-center gap-2">
                        <div className="text-2xl">✨</div>
                        <div>MandaPost</div>
                      </div>
                    </th>
                    <th className="px-6 py-4 text-center font-semibold text-sm">Hootsuite</th>
                    <th className="px-6 py-4 text-center font-semibold text-sm">Buffer</th>
                    <th className="px-6 py-4 text-center font-semibold text-sm">Sprout</th>
                    <th className="px-6 py-4 text-center font-semibold text-sm">Later</th>
                    <th className="px-6 py-4 text-center font-semibold text-sm">Sendible</th>
                  </tr>
                </thead>
                <tbody>
                  {featureComparison.map((category, catIndex) => (
                    <>
                      <tr key={`category-${catIndex}`} className="bg-[#e4f4ff]/20">
                        <td colSpan={7} className="px-6 py-3 font-bold text-[#22577A]">
                          {category.category}
                        </td>
                      </tr>
                      {category.features.map((feature, featIndex) => (
                        <tr
                          key={`feature-${catIndex}-${featIndex}`}
                          className={featIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                        >
                          <td className="px-6 py-4 text-gray-700">{feature.name}</td>
                          <td className="px-6 py-4 text-center">
                            {feature.mandapost ? (
                              <i className="ri-check-line text-[#66b3ff] text-2xl"></i>
                            ) : (
                              <i className="ri-close-line text-gray-300 text-2xl"></i>
                            )}
                          </td>
                          <td className="px-6 py-4 text-center">
                            {feature.hootsuite ? (
                              <i className="ri-check-line text-gray-400 text-xl"></i>
                            ) : (
                              <i className="ri-close-line text-gray-300 text-xl"></i>
                            )}
                          </td>
                          <td className="px-6 py-4 text-center">
                            {feature.buffer ? (
                              <i className="ri-check-line text-gray-400 text-xl"></i>
                            ) : (
                              <i className="ri-close-line text-gray-300 text-xl"></i>
                            )}
                          </td>
                          <td className="px-6 py-4 text-center">
                            {feature.sproutsocial ? (
                              <i className="ri-check-line text-gray-400 text-xl"></i>
                            ) : (
                              <i className="ri-close-line text-gray-300 text-xl"></i>
                            )}
                          </td>
                          <td className="px-6 py-4 text-center">
                            {feature.later ? (
                              <i className="ri-check-line text-gray-400 text-xl"></i>
                            ) : (
                              <i className="ri-close-line text-gray-300 text-xl"></i>
                            )}
                          </td>
                          <td className="px-6 py-4 text-center">
                            {feature.sendible ? (
                              <i className="ri-check-line text-gray-400 text-xl"></i>
                            ) : (
                              <i className="ri-close-line text-gray-300 text-xl"></i>
                            )}
                          </td>
                        </tr>
                      ))}
                    </>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Comparisons */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#22577A] mb-6">
              Head-to-Head Comparisons
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Detailed analysis of how MandaPost compares to each competitor.
            </p>
          </div>

          <div className="space-y-8">
            {detailedComparisons
              .filter((comp) => selectedCompetitor === 'all' || selectedCompetitor === comp.id)
              .map((comparison, index) => (
                <div
                  key={comparison.id}
                  className="bg-gradient-to-br from-gray-50 to-[#e4f4ff]/10 rounded-2xl border-2 border-gray-200 overflow-hidden hover:border-[#66b3ff] transition-all"
                >
                  {/* Header */}
                  <div className="bg-gradient-to-r from-[#22577A] to-[#38a3a5] text-white px-8 py-6">
                    <div className="flex items-center gap-4">
                      <div className="w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl flex items-center justify-center">
                        <i className={`${comparison.icon} text-4xl text-gray-600`}></i>
                      </div>
                      <div className="flex-1">
                        <h3 className="text-3xl font-bold mb-2">
                          MandaPost vs. {comparison.name}
                        </h3>
                        <p className="text-white/90">{comparison.description}</p>
                      </div>
                    </div>
                  </div>

                  {/* Comparison Content */}
                  <div className="p-8">
                    <div className="grid md:grid-cols-2 gap-8 mb-8">
                      {/* Why MandaPost */}
                      <div className="bg-white rounded-xl p-6 border-2 border-[#66b3ff]/30">
                        <div className="flex items-center gap-3 mb-6">
                          <div className="w-12 h-12 bg-gradient-to-br from-[#66b3ff] to-[#b3d9ff] rounded-lg flex items-center justify-center">
                            <i className="ri-star-line text-white text-2xl"></i>
                          </div>
                          <h4 className="text-2xl font-bold text-[#22577A]">Why Choose MandaPost</h4>
                        </div>
                        <ul className="space-y-3">
                          {comparison.whyMandaPost.map((reason, idx) => (
                            <li key={idx} className="flex items-start gap-3">
                              <i className="ri-check-line text-[#66b3ff] text-xl mt-1 flex-shrink-0"></i>
                              <span className="text-gray-700">{reason}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Why Competitor */}
                      <div className="bg-white rounded-xl p-6 border-2 border-gray-200">
                        <div className="flex items-center gap-3 mb-6">
                          <div className="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center">
                            <i className={`${comparison.icon} text-2xl text-gray-600`}></i>
                          </div>
                          <h4 className="text-2xl font-bold text-gray-700">Why Choose {comparison.name}</h4>
                        </div>
                        <ul className="space-y-3">
                          {comparison.whyHootsuite?.map((reason, idx) => (
                            <li key={idx} className="flex items-start gap-3">
                              <i className="ri-check-line text-gray-400 text-xl mt-1 flex-shrink-0"></i>
                              <span className="text-gray-600">{reason}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    {/* Best For */}
                    <div className="grid md:grid-cols-2 gap-6">
                      <div className="bg-gradient-to-br from-[#66b3ff]/20 to-[#b3d9ff]/20 rounded-xl p-6 border-2 border-[#66b3ff]/30">
                        <h5 className="font-bold text-[#22577A] mb-3 flex items-center gap-2">
                          <i className="ri-user-star-line text-[#66b3ff]"></i>
                          MandaPost is Best For:
                        </h5>
                        <p className="text-gray-700">{comparison.bestFor.mandapost}</p>
                      </div>
                      <div className="bg-gray-100 rounded-xl p-6 border-2 border-gray-200">
                        <h5 className="font-bold text-gray-700 mb-3 flex items-center gap-2">
                          <i className="ri-user-line text-gray-400"></i>
                          {comparison.name} is Best For:
                        </h5>
                        <p className="text-gray-600">{comparison.bestFor.competitor}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </section>

      {/* Pricing Comparison */}
      <section className="py-20 bg-gradient-to-br from-[#e4f4ff]/30 to-[#b3d9ff]/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-[#22577A] mb-6">
              Transparent Pricing Comparison
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Get more features for less with MandaPost's competitive pricing.
            </p>
          </div>

          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-6">
            {/* MandaPost */}
            <div className="bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-2xl p-6 text-white shadow-xl transform scale-105 border-4 border-[#66b3ff]">
              <div className="text-center mb-4">
                <div className="text-3xl mb-2">✨</div>
                <h3 className="text-xl font-bold">MandaPost</h3>
              </div>
              <div className="text-center py-6 border-t border-b border-white/20">
                <div className="text-sm text-white/80 mb-1">Starting at</div>
                <div className="text-4xl font-bold">$29</div>
                <div className="text-white/80">/month</div>
              </div>
              <div className="mt-4 text-center">
                <span className="inline-block px-3 py-1 bg-[#66b3ff] text-white text-xs font-bold rounded-full">
                  BEST VALUE
                </span>
              </div>
            </div>

            {/* Competitors */}
            {competitors.map((comp) => (
              <div key={comp.id} className="bg-white rounded-2xl p-6 border-2 border-gray-200 hover:border-gray-300 transition-all">
                <div className="text-center mb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-200 rounded-xl flex items-center justify-center mx-auto mb-2">
                    <i className={`${comp.icon} text-3xl text-gray-600`}></i>
                  </div>
                  <h3 className="text-lg font-bold text-gray-700">{comp.name}</h3>
                </div>
                <div className="text-center py-6 border-t border-b border-gray-200">
                  <div className="text-xs text-gray-500 mb-1">Starting at</div>
                  <div className="text-3xl font-bold text-gray-700">{comp.startingPrice.split('/')[0]}</div>
                  <div className="text-gray-500">/{comp.startingPrice.split('/')[1]}</div>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-gray-600 mb-6">
              *Prices shown are starting prices. See full pricing details on each platform's website.
            </p>
            <a
              href="/pricing"
              className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-[#22577A] to-[#38a3a5] text-white rounded-xl font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all cursor-pointer"
            >
              View MandaPost Pricing
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-[#22577A] to-[#38a3a5] rounded-2xl p-8 lg:p-12 text-white text-center">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-rocket-line text-3xl"></i>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold mb-4">
              Ready to Experience the MandaPost Difference?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              Join thousands of marketers who've switched to MandaPost for smarter, AI-powered social media management.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/pricing"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#22577A] rounded-xl font-semibold text-lg hover:shadow-2xl hover:scale-105 transition-all cursor-pointer"
              >
                <i className="ri-vip-crown-line"></i>
                Start Free Trial
              </a>
              <a
                href="/features"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-xl font-semibold text-lg hover:bg-white/10 transition-all cursor-pointer"
              >
                <i className="ri-list-check"></i>
                See All Features
              </a>
            </div>

            <div className="mt-8 pt-8 border-t border-white/20">
              <p className="text-sm text-white/80">
                No credit card required • 3 months free for early adopters • Cancel anytime
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
